import React from 'react';
import { FormattedMessage } from 'react-intl';

const AppHeaderCenterContainer = () => (
  <div className="header-center-container">
    <div className="header-center-title">
      <FormattedMessage id="header.center.title" tagName="h1" />
    </div>
  </div>
);

export default AppHeaderCenterContainer;
